var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "process" }, [
    _c("div", { staticClass: "container process-body" }, [
      _c("h3", { staticClass: "process-title" }, [_vm._v("代理商申请流程")]),
      _c(
        "div",
        { staticClass: "process-body-list" },
        _vm._l(_vm.contents, function(val, key) {
          return _c("div", { key: key, class: ["process-body-item"] }, [
            _c("div", { staticClass: "process-item-icon" }, [
              _c("img", { attrs: { src: val.icon, alt: val.title } })
            ]),
            _c("h3", { staticClass: "process-item-title" }, [
              _vm._v(_vm._s(val.title))
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85b6db60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85b6db60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/cooperation/Process.vue
// module id = Mxky
// module chunks = 0